import React from 'react';
import { Modal, } from 'antd';
import QRCode from 'qrcode.react';
import './index.less';


const LeaseModal = (props) => {

  const { handleCancel, visible, productId } = props

  console.log(productId, productId)

  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      footer={null}
      className="modalLease1"
      getContainer={false}
      // closable={false}
      width={828}
      zIndex={99999}
    >
      <div className='modalLease_icon' onClick={() => handleCancel()} ></div>
      <div className="modalContainer">

        <div className='modalContainer_title' >
          我要租赁
        </div>
        <div className='modalContainer_content' >
          <div className='modalContainer_content_left' >
            <div className='modalContainer_content_left_pic' >
              <QRCode
                id='ceshi1'
                className={'modalContainer_content_left_pic'}
                size={256}
                imageSettings={{
                  // 二维码中间的logo图片
                  src: 'https://oss.huizustore.com/679f52e3b8594280826d2a81085988ac.png',
                  height: 60,
                  width: 60,
                  excavate: true, // 中间图片所在的位置是否镂空
                }}
                level='H'
                value={productId ? `alipays://platformapi/startapp?appId=${2021004161622584}&page=pages/productDetail/index&query=${encodeURIComponent(`itemId=${productId}`)}` : `alipays://platformapi/startapp?appId=${2021004161622584}&page=pages/home/index`}
              />
            </div>
            <div className='modalContainer_content_left_title' >
              企业租赁 支付宝扫一扫
            </div>
          </div>
          <div className='modalContainer_content_right' >
            <div className='modalContainer_content_right_pic' >
              <QRCode
                id='ceshi1'
                className={'modalContainer_content_right_pic'}
                size={256}
                imageSettings={{
                  // 二维码中间的logo图片
                  src: 'https://oss.huizustore.com/bcaba4058531430fa71b30ae527490a7.png',
                  height: 60,
                  width: 60,
                  excavate: true, // 中间图片所在的位置是否镂空
                }}
                level='H'
                value={productId ? `alipays://platformapi/startapp?appId=${2019011162880259}&page=pages/productDetail/index&query=${encodeURIComponent(`itemId=${productId}`)}` : `alipays://platformapi/startapp?appId=${2019011162880259}&page=pages/home/index`}
              />
            </div>
            <div className='modalContainer_content_right_title' >
              个人租赁 支付宝扫一扫
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default LeaseModal;